export default __webpack_public_path__ + "0e4d98076e71aa19cbedbf9cf4ffd58b.png";